import React, { Suspense, useCallback, useEffect, useState } from "react";
import "./layoutmain.scss";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import logo from "../../assets/icons/Care32-01.png";
import getDecryptedToken from "../../api/getDecryptedToken";
import { BellSvg, UserSvg } from "../../assets/icons";
import Sidebaritem from "../../components/sidebar/Sidebaritem";
import { Circles } from "react-loader-spinner";
import { Outlet, useNavigate } from "react-router-dom";
import baseUrl from "../../api/baseUrl";
import { useDispatch } from "react-redux";
import { io, Socket, connect } from "socket.io-client";
import NightlightIcon from "@mui/icons-material/Nightlight";
import LightModeIcon from "@mui/icons-material/LightMode";
import socketauth from "../../api/socket";
import { setNewPatients } from "../../redux/patients/patientsAction";
import {
  setMyStatusChange,
  setNewAllAppointment,
  setNewPurpose,
  setStatusChange,
} from "../../redux/appointment/appointmentAction";
import ReminderModel from "../../client/components/reminder/ReminderModel";
const clinicName: string | undefined = getDecryptedToken("clinicName");
const userName: string | undefined = getDecryptedToken("userName");
const socket = io(`${process.env.REACT_APP_WS}`, socketauth);
const socketEmit: Socket = connect(`${process.env.REACT_APP_WS}`, socketauth);

function LayoutMain({ filteredArray }: any) {
  const [remainingMs, setRemainingMs] = useState(0);
  const [remainingStr, setRemainingStr] = useState<any>("");
  const [expiryDate, setExpiryDate] = useState<any>("");
  const [expired, setExpired] = useState(false);
  const [pay, setPay] = useState(false);
  const [open, setopen] = useState(window.innerWidth > 499);
  const dispatch = useDispatch();
  const [theme, setTheme] = useState<"light" | "dark">("light");

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
    localStorage.setItem("theme", newTheme); // optional: save to localStorage
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") as "light" | "dark";
    if (savedTheme) {
      setTheme(savedTheme);
      document.documentElement.setAttribute("data-theme", savedTheme);
    }
  }, []);

  const [logout, setlogout] = useState(false);
  const handleSocketUpdate = useCallback(
    (event: any, action: Function) => {
      if (event.token.clinicId === getDecryptedToken("cid")) {
        event.data.new = true;
        dispatch(action(event.data));
      }
    },
    [dispatch]
  );
  const eid = getDecryptedToken("eid");

  useEffect(() => {
    socket.on("updatePatients", (e) => handleSocketUpdate(e, setNewPatients));
    socket.on("allAppointmentStatusChange", (e) =>
      handleSocketUpdate(e, setStatusChange)
    );

    socket.on("myAppointmentStatusChange", (e) => {
      if (eid === e.data.doctorId) {
        console.log(eid, e);
        handleSocketUpdate(e, setMyStatusChange);
      }
    });

    socket.on("uppdateAppointment", (e) => {
      handleSocketUpdate(e, setNewAllAppointment);
    });

    socket.on("uppdateMyAppointment", (e) => {});
    socket.on("updatepurpose", (e) => handleSocketUpdate(e, setNewPurpose));
    return () => {
      socket.off("updatePatients");
      socket.off("uppdateAppointment");
      socket.off("uppdateMyAppointment");
      socket.off("updatepurpose");
    };
  }, [handleSocketUpdate]);

  const getRemaining = (targetDate: Date) => {
    const diff = targetDate.getTime() - Date.now();
    return diff > 0 ? diff : 0;
  };

  // API call to get expiry date
  const getData = useCallback(async () => {
    try {
      const response = await baseUrl.get(
        "client/payment/getCientClinicPaymentbyId"
      );
      if (response?.data?.success) {
        const isoString = response.data.data; // assuming this is the ISO date string
        const target = new Date(isoString);
        setExpiryDate(target);
        const remaining = getRemaining(target);
        setRemainingMs(remaining);
        setPay(remaining === 0);
        updateRemainingStr(remaining);
      } else {
        setPay(false);
      }
    } catch (error: any) {
      console.error(error?.response || error.message);
    }
  }, [baseUrl]);

  // Update readable time string
  const updateRemainingStr = (ms: number) => {
    let secs = Math.floor(ms / 1000);
    const days = Math.floor(secs / 86_400);
    secs %= 86_400;
    const h = String(Math.floor(secs / 3600)).padStart(2, "0");
    const m = String(Math.floor((secs % 3600) / 60)).padStart(2, "0");
    const s = String(secs % 60).padStart(2, "0");
    setRemainingStr(`${days}d ${h}:${m}:${s}`);
  };

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    if (!expiryDate) return;

    const id = setInterval(() => {
      const ms = getRemaining(expiryDate);
      setRemainingMs(ms);
      setExpired(ms === 0);
      updateRemainingStr(ms);
    }, 1000);

    return () => clearInterval(id);
  }, [expiryDate]);
  const closePaymentModel = useCallback(() => {
    setPay(false);
    getData();
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get("https://api.country.is");
  //       localStorage.setItem("country", response.data.country);
  //     } catch (error) {
  //       console.error("Error fetching data: ", error);
  //     }
  //   };

  //   fetchData();
  // }, []);
  const logOut = () => {
    localStorage.clear();
    window.location.reload();
    window.location.href = "/login";
  };

  const handleClose = useCallback(() => {
    if (!(window.innerWidth > 499)) {
      setopen(false);
    }
  }, []);

  const navigate = useNavigate();
  // const { expired, remainingStr } = useExpiry(new Date());

  return (
    <div className="layout_main">
      <div className={`layout_main_nav ${open ? "open_nav" : "close_nav"}`}>
        <div className={`title_head ${open ? "open_nav" : "close_nav"}`}>
          <img src={logo} alt="car32dentsoftware" />
        </div>
        <div className={"side_navigation"}>
          <div className="empty"></div>
          <Sidebaritem
            handleClose={handleClose}
            filteredArray={filteredArray}
          />
        </div>
      </div>
      {open && (
        <label onClick={() => setopen((e) => !e)} className="moileOpen"></label>
      )}

      <div className="layout_main_main">
        <header className={`${open ? "open_header" : "close_header"}`}>
          <div className="layout_main_header">
            <div className="left">
              <button
                className="menu_icon"
                onClick={() => setopen((e) => !e)}
                aria-label="Open menu"
              >
                <MenuOpenIcon />
              </button>
              <div className="title_clinic">{clinicName}</div>
            </div>
            <div className="right">
              <div className="subcrptions">
                <button onClick={() => navigate("pay")}>pay</button>
                <div>
                  {expiryDate.toLocaleString("en-US", {
                    dateStyle: "short",
                    timeStyle: "short",
                  })}
                  <br />
                  {expired ? (
                    <p className="text-red-600 font-semibold">Expired</p>
                  ) : (
                    <p className="text-green-700">
                      <span className="font-mono">{remainingStr}</span>
                    </p>
                  )}
                </div>
              </div>
              <h3>{userName}</h3>
              <div className="notification">
                <button onClick={toggleTheme} className="theme-toggle-btn">
                  {theme === "light" ? (
                    <NightlightIcon />
                  ) : (
                    <LightModeIcon className="nightmode" />
                  )}
                </button>
              </div>
              <div className="notification">
                <BellSvg />
              </div>
              <div className="user_logout">
                <UserSvg onClick={() => setlogout(!logout)} />
                {logout && (
                  <ul>
                    <li onClick={() => logOut()}>Log Out</li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </header>
        <main className={`${open ? "open_header" : "close_header"}`}>
          <Suspense
            fallback={
              <Circles
                height="80"
                width="80"
                color="#174d7a"
                ariaLabel="bars-loading"
                wrapperStyle={{
                  position: "fixed",
                  inset: "0",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                wrapperClass=""
              />
            }
          >
            <Outlet />
          </Suspense>
        </main>
      </div>
      {pay && <ReminderModel closeModel={closePaymentModel} />}
    </div>
  );
}

export default LayoutMain;
